module.exports = {"sclistOld":[{"sc":4024,"details":"AED احلام - أسود - 10 "},{"sc":4022,"details":"AED احلام - بنفسجي - 10 "},{"sc":4148,"details":"AED احلام - أسود - 7 "},{"sc":4142,"details":"AED احلام - أسود - 10 "},{"sc":2337,"details":"AED احلام - أزرق - 10 "},{"sc":6877,"details":"AED احلام - بني - 10 "},{"sc":6055,"details":"AED احلام - أخضر - 10 "},{"sc":4060,"details":"AED رقم قف - أصفر - 0.30 "},{"sc":7570,"details":"AED شورت كود قديم"}]}


//////////////////
// WEBPACK FOOTER
// ./src/sc_old.json
// module id = 326
// module chunks = 0